import React, { useState, useEffect } from 'react';
import "../technology/technology.css";
import HNavbar from '../../Components/Navbar/HNavbar';
import MFooter from '../../Components/Main-Footer/MFooter';
import performance from "../../Assets/performance.png";
import graph from "../../Assets/tech-graph.png";

function Technology() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <HNavbar />
            {/* ===== HERO ===== */}
            <section className="tech-sb-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-xl-5">
                            <div className="tech-hero-tag">our technology</div>
                            <h1 className="tech-hero-title">
                                <span className="orange">Advanced Engineering.</span><br />
                                Superior Performance.
                            </h1>
                            <p className="tech-hero-desc">
                                Our sound barrier systems combine innovative design, premium materials and precision manufacturing to deliver outstanding noise reduction, durability and long-term value.
                            </p>

                            <div className="d-flex flex-wrap gap-3 my-3 tech-feature-icons-row">
                                {[
                                    {
                                        icon: "fa fa-solid fa-wave-square", label: "Up to 35 dB\nNoise Reduction"
                                    },
                                    { icon: "fa fa-solid fa-shield-halved", label: "Weather & UV\nResistant" },
                                    { icon: "fa fa-solid fa-fire", label: "Fire Retardant\n& Safe" },
                                    { icon: "fa fa-regular fa-clock", label: "Long Life Span\n15+ Years" },
                                ].map((f) => (
                                    <div className="product-feature-icon-item" key={f.label}>
                                        <i className={f.icon}></i>
                                        <span>{f.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ===== PERFORMANCE ===== */}
            < section className="product-performance" >
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-sm-6 col-md-6 order-md-1 order-2">
                            <div className='abtsb-img'>
                                <img src={performance} alt='sb'></img>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6 order-md-2 order-1">
                            <div className="tech-performance-box">
                                <h5>DIFFRACTION PERFORMANCE FACTORS</h5>
                                <div className="diffraction-box">
                                    {/* <h5>Diffraction Performance Factors</h5> */}

                                    <div className="diffraction-item">
                                        <div className="diffraction-icon"><i className="fa-solid fa-water"></i></div>
                                        <div className="diffraction-text">
                                            <strong>Barrier Height</strong>
                                            <span>Higher barriers increase the path difference and reduce diffracted sound.</span>
                                        </div>
                                    </div>

                                    <div className="diffraction-item">
                                        <div className="diffraction-icon"><i className="fa-solid fa-weight-hanging"></i></div>
                                        <div className="diffraction-text">
                                            <strong>Surface Mass</strong>
                                            <span>Higher mass panels block more sound energy.</span>
                                        </div>
                                    </div>

                                    <div className="diffraction-item">
                                        <div className="diffraction-icon"><i className="fa-solid fa-circle-dot"></i></div>
                                        <div className="diffraction-text">
                                            <strong>Absorptive Core</strong>
                                            <span>Absorbs residual sound energy within the barrier system.</span>
                                        </div>
                                    </div>

                                    <div className="diffraction-item">
                                        <div className="diffraction-icon"><i className="fa-solid fa-link"></i></div>
                                        <div className="diffraction-text">
                                            <strong>Continuous Seal</strong>
                                            <span>Minimizes gaps and flanking paths for better overall performance.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            {/* ACOUSTICS PRINCIPLES */}
            < section className="principle" >
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-sm-6 col-md-6">
                            <div className="tech-performance-box">
                                <h5 className='principle-acoustics'>ACOUSTIC PRINCIPLE <br />SOUND BARRIER DIFFRACTION</h5>
                                <p className="principle-hero-desc" style={{ textAlign: "justify" }}>
                                    Sound barriers control noise by blocking the direct path between the source and receiver. Sound waves diffract (bend) over the top edge of the barrier. Our system reduces this diffracted sound through a combination of height, mass, absorption and precision engineering.
                                </p>
                                {["High surface mass blocks more sound", "Greater height reduces line-of-sight", "Absorptive core minimizes reflectionsAbsorptive core minimizes reflections", "Precision design reduces diffraction"].map((item) => (
                                    <div className="challenge-item" key={item}>
                                        <i className="fa fa-check-circle"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-6">
                            <div className='abtsb-img'>
                                <img src={graph} alt='sb'></img>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section className="container how-it-works">

                {/* <!-- HEADING --> */}
                <div className="process-heading">
                    <h3>How Our Technology Works</h3>
                </div>

                {/* <!-- ROW 1: PROCESS STEPS --> */}
                <div className="process-row">

                    <div className="process-step">
                        <div className="step-icon"><i className="fa-solid fa-wave-square"></i></div>
                        <div className="step-text">
                            <span className="step-num">01</span>
                            <strong>Sound Generation</strong>
                            <p>Noise is generated from traffic, industry or construction.</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="process-step">
                        <div className="step-icon"><i className="fa-solid fa-bars"></i></div>
                        <div className="step-text">
                            <span className="step-num">02</span>
                            <strong>Sound Interception</strong>
                            <p>Sound waves travel towards the barrier as incident sound.</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="process-step">
                        <div className="step-icon"><i className="fa-solid fa-diagram-project"></i></div>
                        <div className="step-text">
                            <span className="step-num">03</span>
                            <strong>Diffraction Over Barrier</strong>
                            <p>Sound waves bend over the top edge of the barrier.</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="process-step">
                        <div className="step-icon"><i className="fa-solid fa-grip-lines-vertical"></i></div>
                        <div className="step-text">
                            <span className="step-num">04</span>
                            <strong>Energy Reduction</strong>
                            <p>The system absorbs, blocks and dissipates sound energy.</p>
                        </div>
                    </div>

                    <i className="fa-solid fa-arrow-right step-arrow"></i>

                    <div className="process-step">
                        <div className="step-icon"><i className="fa-solid fa-ear-listen"></i></div>
                        <div className="step-text">
                            <span className="step-num">05</span>
                            <strong>Noise Reduction</strong>
                            <p>Reduced sound reaches the receiver creating a quieter environment.</p>
                        </div>
                    </div>

                </div>
                {/* 
                <!-- ROW 2: BENEFITS STRIP --> */}
                <div className="benefits-row">

                    <div className="benefit-item">
                        <div className="benefit-icon"><i className="fa-solid fa-leaf"></i></div>
                        <div className="benefit-text">
                            <strong>Sustainable Solutions</strong>
                            <p>Eco-friendly materials and recyclable components for a greener tomorrow.</p>
                        </div>
                    </div>

                    <div className="benefit-item">
                        <div className="benefit-icon"><i className="fa-solid fa-award"></i></div>
                        <div className="benefit-text">
                            <strong>Tested &amp; Certified</strong>
                            <p>Tested in accordance with international standards for proven acoustic performance.</p>
                        </div>
                    </div>

                    <div className="benefit-item">
                        <div className="benefit-icon"><i className="fa-solid fa-gear"></i></div>
                        <div className="benefit-text">
                            <strong>Quality Manufacturing</strong>
                            <p>Precision manufacturing and strict quality control for consistent reliability.</p>
                        </div>
                    </div>

                    <div className="benefit-item">
                        <div className="benefit-icon"><i className="fa-solid fa-screwdriver-wrench"></i></div>
                        <div className="benefit-text">
                            <strong>Easy Installation</strong>
                            <p>Modular design for faster installation and reduced on-site disruption.</p>
                        </div>
                    </div>

                    <div className="benefit-item">
                        <div className="benefit-icon"><i className="fa-solid fa-headset"></i></div>
                        <div className="benefit-text">
                            <strong>Technical Support</strong>
                            <p>Expert guidance from design to commissioning and after-sales support.</p>
                        </div>
                    </div>

                </div>

            </section>

            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )
            }
            <MFooter />
        </>
    )
}

export default Technology